import { inject, Injectable } from '@angular/core';
import { DeliveryModeStore } from '@lentau/delivery-mode/store/delivery-mode.store';

@Injectable({
  providedIn: 'root',
})
export class PickupResetService {
  private readonly deliveryModeStore: DeliveryModeStore = inject(DeliveryModeStore);

  public reset(): void {
    this.deliveryModeStore.resetPickup();
  }
}
